import Box from '@mui/material/Box';

import IconButton from '@design-system/IconButton';
import IconArrowBack from '@experimental-components/IconsComponents/ArrowBack';

import IconClose from '@experimental-components/IconsComponents/Close';

import clsx from 'clsx';

import useStyles from './styles';

interface StepperStartContentDialogProps {
  children: React.ReactNode;
  activeStep: number;
  onBack: () => void;
  hideBack: boolean;
  isMobileVersion: boolean;
  onClose: () => void;
  variant?: 'black' | 'white';
}

export function StepperStartContentDialog({
  children,
  activeStep,
  onBack,
  hideBack,
  isMobileVersion,
  onClose,
  variant = 'black',
}: StepperStartContentDialogProps) {
  const classes = useStyles();

  return (
    <Box
      className={clsx(
        classes.rootSectionSteps,
        variant === 'black' ? classes.rootSectionStepsBlack : classes.rootSectionStepsWhite,
      )}
    >
      <Box className={classes.wrapperSectionSteps}>
        <Box className={classes.contentSteps}>
          <Box className={classes.headerContentSteps}>
            <Box>
              {activeStep !== 1 && !hideBack && (
                <IconButton disabled={activeStep === 1} onClick={onBack} size="large">
                  <IconArrowBack color="#ffffff" size={isMobileVersion ? 20 : 24} />
                </IconButton>
              )}
            </Box>
            {isMobileVersion && (
              <IconButton onClick={onClose} size="large">
                <IconClose color="#ffffff" size={isMobileVersion ? 16 : 24} />
              </IconButton>
            )}
          </Box>
          {!isMobileVersion && <Box flex="1 1 auto" />}
          <Box>{children}</Box>
          {!isMobileVersion && <Box flex="1 1 auto" />}
        </Box>
      </Box>
    </Box>
  );
}
